export enum UserTypeEnum {
  CLIENT = 'CLIENT',
  BARMAN = 'BARMAN'
}
